module.exports = __webpack_public_path__ + "static/logo-8191f6c113c1e92e06743efff3e469f3.jpg";